import React from "react";
// import { IconShare2 } from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import NoImageAvailable from "../../assets/images/no-image-available.jpg";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const settings = {
    dots: false, // Hiển thị dấu chấm dưới ảnh
    infinite: true, // Quay vòng qua các ảnh
    speed: 500, // Thời gian chuyển đổi giữa các ảnh
    slidesToShow: 1, // Hiển thị một ảnh tại một thời điểm
    slidesToScroll: 1, // Mỗi lần chuyển một ảnh
    autoplay: true, // Tự động chuyển ảnh sau mỗi 5 giây
    autoplaySpeed: 5000, // Thời gian chuyển ảnh (5 giây)
    arrows: false,
  };

  function handleUploadImageError(event) {
    event.target.src = NoImageAvailable;
  }

  if (!product) return;
  return (
    <div
      className="bg-white rounded-lg p-4 flex flex-col items-center relative hover:cursor-pointer"
      style={{
        boxShadow: "0 4px 6px rgb(0 0 0 / 0.15), 0 -4px 6px rgb(0 0 0 / 0.15)",
      }}
      onClick={() => navigate(`/products/${product.category}/${product.slug}`)}
    >
      {/* <button className="absolute top-2 right-2" data-tooltip={"Chia sẻ"}>
        <IconShare2 className="w-5 h-5 stroke-gray-500 hover:stroke-black" />
      </button> */}
      {product.images.length > 1 ? (
        <div className="w-32 lg:h-40 h-28 relative">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full">
            <Slider {...settings}>
              {product.images.map((image, index) => (
                <div key={index}>
                  <img
                    src={image?.src || NoImageAvailable}
                    alt={`product-image-${index}`}
                    className="object-contain w-full h-24 lg:h-36"
                    onError={handleUploadImageError}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      ) : (
        // Nếu chỉ có một ảnh, hiển thị ảnh bình thường
        <div className="w-32 lg:h-40 h-28">
          <img
            src={product.images[0]?.src || NoImageAvailable}
            alt="product-image"
            className="object-contain w-full h-full"
            onError={handleUploadImageError}
          />
        </div>
      )}

      <div className="text-center">
        <p className="text-sm lg:text-base font-semibold text-gray-800 mt-2 line-clamp-1">
          {product.name}
        </p>
      </div>
      <button
        className="mt-4 lg:px-8 px-4 py-2 bg-primaryColor text-white rounded-md hover:bg-gray-800 hover:scale-110 text-nowrap white-space-nowrap
      "
      >
        Mua ngay
      </button>
    </div>
  );
};

export default ProductCard;
